/**
 * @generated SignedSource<<916797107d05459f0e477c01b36e550f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_seller$data = {
  readonly monthsSinceStartDate: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContact_seller" | "useSellerRating_seller">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_seller";
};
export type PdpRespSidebarSellerInfoAndContactLazy_seller$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_seller",
  "selections": [
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContact_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSellerRating_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "cf3bffb1fca180a9ee2468bac80d4777";

export default node;
